import apiClient from '../utils/apiClient';

/**
 * Table API Services
 * Quản lý bàn
 */

const buildTablePayload = (data = {}) => {
  const payload = {};
  if (data.branchId !== undefined) payload.branch_id = data.branchId;
  if (data.storeId !== undefined && payload.branch_id === undefined) {
    payload.branch_id = data.storeId;
  }
  if (data.number !== undefined) payload.number = Number(data.number);
  if (data.slug !== undefined) payload.slug = data.slug;
  if (data.capacity !== undefined) payload.capacity = data.capacity;
  if (data.isAvailable !== undefined) payload.is_available = data.isAvailable;
  if (data.isActive !== undefined) payload.is_active = data.isActive;
  // Phòng + override hành động dọn ('' = khu chung, backend coerce null)
  if (data.roomId !== undefined) payload.room_id = data.roomId;
  if (data.cleanupActionsOverride !== undefined) {
    payload.cleanup_actions_override = data.cleanupActionsOverride;
  }
  return payload;
};

export const tableAPI = {
  /**
   * Lấy danh sách bàn
   * @param {Object} params - Tham số truy vấn
   * @param {string} params.branchId - Lọc theo chi nhánh
   * @returns {Promise<Object>} Danh sách bàn
   */
  getTables: async (params = {}) => {
    return await apiClient.get({
      url: '/tables',
      params,
    });
  },

  /**
   * Lấy thông tin chi tiết một bàn
   * @param {string} tableId - ID bàn
   * @returns {Promise<Object>} Thông tin chi tiết bàn
   */
  getTableById: async (tableId) => {
    return await apiClient.get({
      url: `/tables/${tableId}`,
    });
  },

  /**
   * Tạo bàn mới
   * @param {Object} tableData - Dữ liệu bàn
   * @param {string} tableData.branchId - ID chi nhánh
   * @param {number} tableData.number - Số bàn (integer >= 1)
   * @param {string} tableData.slug - Slug bàn
   * @param {number} tableData.capacity - Sức chứa
   * @param {boolean} tableData.isAvailable - Trạng thái trống/đang dùng
   * @param {boolean} tableData.isActive - Trạng thái hoạt động
   * @returns {Promise<Object>} Thông tin bàn vừa tạo
   */
  createTable: async (tableData) => {
    return await apiClient.post({
      url: '/tables',
      data: buildTablePayload(tableData),
    });
  },

  /**
   * Cập nhật thông tin bàn
   * @param {string} tableId - ID bàn
   * @param {Object} updateData - Dữ liệu cập nhật
   * @returns {Promise<Object>} Thông tin bàn sau khi cập nhật
   */
  updateTable: async (tableId, updateData) => {
    return await apiClient.put({
      url: `/tables/${tableId}`,
      data: buildTablePayload(updateData),
    });
  },

  /**
   * Xóa bàn
   * @param {string} tableId - ID bàn
   * @returns {Promise<Object>} Kết quả xóa
   */
  deleteTable: async (tableId) => {
    return await apiClient.delete({
      url: `/tables/${tableId}`,
    });
  },

  /**
   * Cập nhật trạng thái bàn (trống/đang dùng)
   * @param {string} tableId - ID bàn
   * @param {boolean} isAvailable - Trạng thái có sẵn
   * @returns {Promise<Object>} Kết quả cập nhật
   */
  updateTableAvailability: async (tableId, isAvailable) => {
    return await apiClient.patch({
      url: `/tables/${tableId}/availability`,
      data: { is_available: isAvailable },
    });
  },

  /**
   * Tạo/lấy QR Code cho bàn
   * @param {string} tableId - ID bàn
   * @returns {Promise<Object>} QR code (URL hoặc base64)
   */
  getTableQRCode: async (tableId) => {
    return await apiClient.get({
      url: `/tables/${tableId}/qrcode`,
    });
  },
};
